import React, { useEffect, useState } from "react";
import './FAQNew.css';
import SearchIcon from "@mui/icons-material/Search";
import { Container, InputAdornment } from "@mui/material";
import Box from "@mui/material/Box";
import Input from "@mui/material/Input";
import { ATCGNFaqData } from '../data/ATCGNFAQData';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FAQNew = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value.toLowerCase());
    };
    const stripHtml = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    };

    const filterFaqs = (faqList) => {
        return faqList.filter(item =>
            item.Question.toLowerCase().includes(searchTerm) ||
            stripHtml(item.Answer).toLowerCase().includes(searchTerm)
        );
    };
    const requestorFaqs = filterFaqs(ATCGNFaqData[0].Requestor);
    const participantFaqs = filterFaqs(ATCGNFaqData[0].Participant);
    return (
        <>
            <div className="banner-container">
                <img src="images/FAQ/Banner.png" alt="banner-img" className="banner" />
            </div>
            <div className="faq-outer">
                <div className="faq-container">
                    <div className="faq-header">
                        <h2>Get all your queries answered</h2>
                        <div className="search-container">
                            <Container maxWidth="md" sx={{ mt: 20 }} className="search-inner-container">
                                <div className="search-wrap">
                                    <img
                                        src="images/FAQ/search-icon.png"
                                        alt="search-icon"
                                        className="search-icon"
                                    />
                                    <label for="search" className="sr-only" style={{ display: "none" }}>
                                        Search your question
                                    </label>
                                    <Input
                                        id="search"
                                        type="search"
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                        sx={{ width: 430, border: 1, borderColor: "lightGray" }}
                                        disableUnderline
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </div>
                            </Container>
                        </div>
                    </div>
                    <p>
                        We have compiled a list of frequently asked questions from training requestors and participants. Please find answers to common questions in our FAQ.  Training requestors can refer to the “Requestor” FAQ section. Participants can go through Participants FAQ section for more details.
                    </p>
                </div>
            </div>

            <Box className="accordion_header_section">
                <h3 className="faq_header">Requestor</h3>
                <div className="custom_accordion">
                    {requestorFaqs.map((item, index, array) => {
                        const isFirst = index === 0;
                        const isLast = index === array.length - 1;
                        const accordionClass = `accordion-default ${isFirst || isLast ? 'accordion-no-radius' : ''}`;

                        return (
                            <Accordion key={item.id} className={accordionClass}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel-content-${item.id}`}
                                    id={`panel-header-${item.id}`}
                                    className="accordion-summary"
                                >
                                    <Typography component="span" className="accordion_typography">{item.Question}</Typography>
                                </AccordionSummary>
                                <AccordionDetails className="accordion-details">
                                    <div
                                        dangerouslySetInnerHTML={{ __html: item.Answer }}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        );
                    })}

                </div>
                <h3 className="faq_header">Participant</h3>
                <div className="custom_accordion">
                    {participantFaqs.map((item, index, array) => {
                        const isFirst = index === 0;
                        const isLast = index === array.length - 1;
                        const accordionClass = `accordion-default ${isFirst || isLast ? 'accordion-no-radius' : ''}`;

                        return (
                            <Accordion key={item.id} className={accordionClass}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel-content-${item.id}`}
                                    id={`panel-header-${item.id}`}
                                    className="accordion-summary"
                                >
                                    <Typography component="span" className="accordion_typography">{item.Question}</Typography>
                                </AccordionSummary>
                                <AccordionDetails className="accordion-details">
                                    <div
                                        dangerouslySetInnerHTML={{ __html: item.Answer }}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        );
                    })}

                </div>
            </Box>
        </>
    )
}

export default FAQNew;